module.exports = __webpack_public_path__ + "img/check-circle.1c22d3b9.svg";